import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import SitePage, { CallToAction, styles, T } from '../components/site/SitePage';

const PartenairesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SitePage>
      <SEO
        title="Nos partenaires"
        description="Les partenaires d'Autoria : Ascension Marketing, agence marketing 360 à Annecy, pour la stratégie, le site, l'e-commerce, les contenus et l'acquisition."
        path="/partenaires"
        breadcrumb={[['Nos partenaires', '/partenaires']]}
      />
      <section style={{ ...styles.container, padding: '72px 24px 0', display: 'flex', flexDirection: 'column', gap: 16 }}>
        <p style={styles.kicker}>Partenaires</p>
        <h1 style={styles.h1}>Nos partenaires</h1>
      </section>

      <section id="ascension-marketing" style={{ ...styles.container, paddingTop: 40 }}>
        <article style={{ padding: 'clamp(24px, 4vw, 40px)', background: '#FFFFFF', border: `1px solid ${T.line2}`, borderRadius: 8, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '28px 56px' }}>
          <img src="/img/partenaires/ascension-marketing.svg" alt="Ascension Marketing" width="266" height="120" style={{ flex: '0 0 auto', width: 'min(240px, 100%)', height: 'auto' }} />
          <div style={{ flex: '1 1 380px', minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 14 }}>
            <p style={styles.kicker}>Agence marketing 360 · Annecy</p>
            <p style={{ margin: 0, fontSize: 18, color: T.text }}>Stratégie, site web, e‑commerce, contenus et acquisition, de l'audit à la mise en œuvre.</p>
            <a href="https://ascensionmarketing.fr/" target="_blank" rel="noopener" className="lift" style={{ ...styles.button, marginTop: 6 }}>Découvrir Ascension Marketing</a>
          </div>
        </article>
      </section>

      <CallToAction from="partenaires" />
    </SitePage>
  );
};

export default PartenairesPage;
